import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AuthGate from './components/AuthGate';
import UpdateBanner from './components/UpdateBanner';
import './iphone.css'; // after App so it wins over the page styles it adjusts
import PublicReport from './pages/Routes/PublicReport';
import { reportTokenFromPath } from './pages/Routes/reportData';
import reportWebVitals from './reportWebVitals';

// /r/<token> is the customer's report link — it renders on its own, without the dashboard
const reportToken = reportTokenFromPath(window.location.pathname, window.location.search);

// the staff app is navy edge to edge (no white under the content on iPhone); customer reports keep their own look
if (reportToken === null) document.documentElement.classList.add('cie-app');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {reportToken !== null ? (
      <PublicReport token={reportToken} />
    ) : (
      <>
        <AuthGate>
          <App />
        </AuthGate>
        <UpdateBanner />
      </>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
